import React, { useState, useEffect, useRef } from "react";
import { connect } from "react-redux";
import SideBar from "../common/sideBar";
import { postServerDataWithPath } from "../../../action/common_action";
import {
  axiosInstnace as Axios,
  calculateAmountAndTax,
} from "../../../util/util";
import { endPoints } from "../../../config";
import { history } from "../../../history/history";
import useModel from "./useModel";
import ApproveModel from "../common/approveModel";
import RejectModel from "../common/rejectModel";
import NoData from "../common/NoData";
import Pagination from "../common/Pagination";
import ExcelPopup from "./ExcelPopup";
import UploadContract from "./UploadContract";
import DatePicker from "react-datepicker";
import { addDays, addMonths } from "date-fns";
import moment from "moment";
import HeaderAdminpanel from "../common/HeaderAdminpanel";
import Dropdown from "react-dropdown";
import LinkPayment from "./LinkPayment";
import ViewStationsModal from "../audioadminmanagment/ViewStationsModal";
import VerifyReconciledPayment from "./VerifyReconciledPayment";

const DeletedCampaigns = (props) => {
  const [audioStateArr] = useState(["New", "Link Payment", "Delete"]);

  const [campaigns, handleCampaignList] = useState([]);
  const [startDate, setStartDate] = useState(undefined);
  const [endDate, setEndDate] = useState(undefined);
  const [packagetype, handlePackagetype] = useState(undefined);
  const [showstationlist, handleshowstationlist] = useState(false);
  const [currentStations, handleCurrentStations] = useState([]);

  const [campaignstatustype, handleCampaignstatustype] = useState(undefined);

  const [razorpay, handleRazorpay] = useState(undefined);
  const searchRazorpay = useRef(undefined);

  const [station, handleStation] = useState(undefined);
  const [email, handleEmail] = useState(undefined);
  const [searchName, handleSearchName] = useState(undefined);
  //vj
  // const [searchStation, handleSearchStation] = useState(undefined);
  const [skip, handleSkip] = useState(0);
  const [count, handleCount] = useState(0);
  const campaignName = useRef(undefined);
  const userEmail = useRef(undefined);
  const searchStation = useRef(station);
  const adminInfo = JSON.parse(localStorage.getItem("adminInfo"));
  
  const [searchCampaignId, handleSearchCampaignId] = useState(undefined);
  

  // const packagetype = useRef(undefined);

  useEffect(() => {
    getCampaignlist(0, undefined, undefined, "Deleted", false);
  }, []);

  //Fetching the campaign list
  const getCampaignlist = async (skip, name, id, status, reset) => {
    var paramsConstrct;
    if (!reset) {
      
      if (adminInfo.role !== "stationAdmin") {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: searchStation.current.value,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
          campaigntype: "Deleted",
          cluster: adminInfo.cluster,
        };
      } else {
        paramsConstrct = {
          skip,
          name: campaignName.current.value,
          userEmail: userEmail.current.value,
          station: adminInfo.station,
          _id: id,
          startDate: startDate,
          endDate: endDate,
          packageType:
           packagetype,
          campaignstatustype: campaignstatustype,
          campaigntype: "Deleted",
        };
      }
    }
    handleSkip(skip);
    try {
      const data = await Axios.get(endPoints.getAllCampaign, {
        params: paramsConstrct,
      });
      let result = data.data.data.data;
      if (result) {
        result = result.map((campaign) => {
          return calculateAmountAndTax(campaign);
        });
        handleCampaignList(result);
        handleSearchName(name);
        handleRazorpay(razorpay);
        handleCount(data.data.data.count);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const callSearch = () => {
    getCampaignlist(0, undefined, searchCampaignId, "Pending", false);
  };

  const clearSearch = () => {
    window.location.reload(true);
  };

  
  //Return the table for campaign
  return (
    <div>
      <div className="dashboardContainer">
        <HeaderAdminpanel />
        <div className="dashboardContainer-inner">
          <section id="sidebar">
            <SideBar />
          </section>{" "}
          <section
            id="dashboard-rightContainer"
            className="dashboard-manageSales"
          >
            <div className="container-head">
              <div className="dashboard-breadcrumb">
                Campaign Management |
                <span className="breadcrumb-active advertiser-breadcrumb">
                 Deleted Campaign List{" "}
                </span>{" "}
              </div>
            </div>
            <form id="search-campaign-form" action="">
              <table cellPadding="10" cellSpacing="10" className="searchTable">
                <tbody>
                  <tr>
                    <td>
                      <div
                        className={
                          !searchCampaignId && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          placeholder="Enter campaign Id"
                          onChange={ (e)=> { handleSearchCampaignId(e.target.value)}}
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    
                    <td>
                      <div
                        className={
                          !searchName && campaigns.length === 0
                            ? "search_camp none search-container"
                            : "search_camp search_list search-container"
                        }
                      >
                        {/*<input type="text" placeholder="Campaignname search" onChange={getSearch}/>*/}{" "}
                        <input
                          type="text"
                          ref={campaignName}
                          placeholder="Enter campaign name"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>
                    
                    <td>
                      <div
                        className={
                          !email && campaigns.length === 0
                            ? "search_camp none"
                            : "search_camp search_list"
                        }
                      >
                        <input
                          type="text"
                          ref={userEmail}
                          placeholder="Email"
                        />
                        <span>
                          <img src="/assets/images/search.png" />
                        </span>{" "}
                      </div>{" "}
                    </td>

                    <td>
                      <div className="print_btn">
                        <button type="button" onClick={callSearch}>
                          Search{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>{" "}
                    <td>
                      <div className="print_btn">
                        {" "}
                        {/***  <button type="button" onClick={clearSearch}>Clear</button>*/}{" "}
                        <button type="reset" onClick={clearSearch}>
                          Clear{" "}
                        </button>{" "}
                      </div>{" "}
                    </td>
                    <td> </td>{" "}
                  </tr>
                  
                </tbody>{" "}
              </table>{" "}
            </form>{" "}
            <div
              className={
                campaigns.length === 0
                  ? "dashboard-content userListing-dashboard bg-white table-responsive none"
                  : "dashboard-content userListing-dashboard bg-white table-responsive"
              }
            >
              <table className="table table-striped master-table">
                <thead>
                  <tr>
                    <th> CampaignId </th>
                    <th> Campaign Name </th>
                    <th> Created Date </th>{" "}
                    <th> Station </th>{" "}
                    <th> User Email </th>
                    <th> Price </th>{" "}
                  </tr>{" "}
                </thead>{" "}
                <tbody>
                  {" "}
                  {campaigns.map((c, i) => (
                    <tr key={i}>
                      <td> {c._id} </td>
                      <td> {c.name} </td>{" "}
                      <td> {moment(c.createdAt).format("DD/MM/YYYY")} </td>{" "}
                      <td> {c.station.includes(",") ? (
                              <a
                                onClick={(e) => {
                                  handleshowstationlist(true);
                                  handleCurrentStations(c.station.split(","));
                                }}
                              >
                                Multiple ({c.station.split(",").length})
                              </a>
                            ) : (
                              c.station
                            )} </td>{" "}
                      
                      <td> {c.userEmail} </td>{" "}
                      <td> {c.totalCost} </td>{" "}
                    </tr>
                  ))}{" "}
                </tbody>{" "}
              </table>{" "}
              <div className="paginationTable" />{" "}
              {(skip > 0 || count > 10) && (
                <Pagination getAllData={getCampaignlist} totalRecords={count} />
              )}{" "}
            </div>{" "}
            {campaigns.length === 0 ? <NoData /> : null}{" "}
          </section>{" "}
        </div>{" "}
      </div>{" "}
    </div>
  );
};

const mapDispatchToProps = (dispatch) => {
  return {
    updateCampaign: (url, data, path) =>
      dispatch(postServerDataWithPath(url, data, path)),
  };
};

export default connect(null, mapDispatchToProps)(DeletedCampaigns);



// WEBPACK FOOTER //
// ./web/components/admin/manageCampaign/deletedcampaigns.js